import { useRegisterSW } from "virtual:pwa-register/react";
import { toast } from "sonner";
import { useEffect } from "react";
import { DownloadCloud, RefreshCw } from "lucide-react";

export function PwaPrompt() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error("SW registration error", error);
    },
  });

  useEffect(() => {
    if (offlineReady) {
      toast.success("App ready for offline use", {
        description: "You can now use PDFWorkSpace without an internet connection.",
        icon: <DownloadCloud className="h-5 w-5 text-emerald-500" />,
        duration: 5000,
      });
    }
  }, [offlineReady]);

  useEffect(() => {
    if (needRefresh) {
      toast.message("Update Available", {
        description: "A new version of PDFWorkSpace is available.",
        icon: <RefreshCw className="h-5 w-5 text-blue-500" />,
        duration: Infinity,
        action: {
          label: "Update Now",
          onClick: () => updateServiceWorker(true),
        },
        onDismiss: () => setNeedRefresh(false),
      });
    }
  }, [needRefresh, setNeedRefresh, updateServiceWorker]);

  return null; // Purely logic/toast based
}
